import React from "react";
import { TicketSaveFormInstanceContext } from "../context/TicketSaveFormInstanceContext";

export const useTicketSaveFormInstance = () => {
  const formInstance = React.useContext(TicketSaveFormInstanceContext);
  return { formInstance };
};
